module.exports = __webpack_public_path__ + "static/media/algo-pasa-pero-no-se-que.b28544a7.png";